/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module UpdateModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import {
    ClrAccordionModule,
    ClrCheckboxModule,
    ClrDatagridModule,
    ClrDropdownModule,
    ClrInputModule,
    ClrSpinnerModule,
    ClrTabsModule,
    ClrTextareaModule,
    ClrWizardModule,
} from '@clr/angular';

import { AviCardModule } from 'nsx-alb-ui-components';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'ng/modules/core/core.module';
import { DataGridModule } from 'ng/modules/data-grid/data-grid.module';
import { DialogModule } from 'ng/modules/dialog/dialog.module';
import { FormsModule } from '@angular/forms';
import { LoaderModule } from 'ng/modules/loader/loader.module';
import { SharedModule } from 'ng/shared/shared.module';
import { SystemModule } from 'ng/modules/system/system.module';
import { SystemReportSummaryModule } from 'ng/modules/system-report-summary/system-report-summary.module';
import { UIRouterModule } from '@uirouter/angular';
import { VIPModule } from '@vmw/ngx-vip';

import { imageCollectionProvider } from './ajs-upgraded-provider';
import { UpdateStore } from './components/update.store';

import {
    ComplianceModeConfirmationComponent,
    DryRunReportComponent,
    PrechecksListComponent,
    PrechecksListExpanderComponent,
    PreCheckWizardPageComponent,
    ProgressNoteComponent,
    RecentUpdatesListComponent,
    SegImageSelectionComponent,
    SegUpdateGridExpanderComponent,
    SegUpdatePageComponent,
    SelectedSegListComponent,
    SystemAboutCardComponent,
    SystemUpdateAboutCardComponent,
    SystemUpdateComponent,
    UpdateCardComponent,
    UpdateNodeStatusCardComponent,
    UpdatePageComponent,
    UpdateProgressCardComponent,
    UpdateWizardComponent,
    UpgradeTranscriptModalComponent,
} from './components';

const updateComponents = [
    ComplianceModeConfirmationComponent,
    DryRunReportComponent,
    PrechecksListComponent,
    PrechecksListExpanderComponent,
    PreCheckWizardPageComponent,
    ProgressNoteComponent,
    RecentUpdatesListComponent,
    SegImageSelectionComponent,
    SegUpdateGridExpanderComponent,
    SegUpdatePageComponent,
    SelectedSegListComponent,
    SystemAboutCardComponent,
    SystemUpdateAboutCardComponent,
    SystemUpdateComponent,
    UpdateCardComponent,
    UpdateNodeStatusCardComponent,
    UpdatePageComponent,
    UpdateProgressCardComponent,
    UpdateWizardComponent,
    UpgradeTranscriptModalComponent,
];

/**
 * Module containing all upgrade stuff (angular only).
 */
@NgModule({
    declarations: [
        ...updateComponents,
    ],
    exports: [
        RecentUpdatesListComponent,
        UpgradeTranscriptModalComponent,
    ],
    imports: [
        AviCardModule,
        AviFormsModule,
        ClrAccordionModule,
        ClrCheckboxModule,
        ClrDatagridModule,
        ClrDropdownModule,
        ClrInputModule,
        ClrSpinnerModule,
        ClrTabsModule,
        ClrTextareaModule,
        CommonModule,
        CoreModule,
        FormsModule,
        DialogModule,
        SharedModule,
        SystemModule,
        VIPModule,
        LoaderModule,
        DataGridModule,
        ClrTabsModule,
        ClrWizardModule,
        SystemReportSummaryModule,
        UIRouterModule.forChild(),
    ],
    providers: [
        imageCollectionProvider,
        UpdateStore,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class UpdateModule { }
